import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import {
    getdiscrepancyCollection,
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
} from "@tKgpco/Services/DiscrepancyService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<DiscrepancyCollectionParam, DiscrepancyCollectionResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/BeginLoadDiscrepancyCollection",
        params: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getdiscrepancyCollection(props.parameter);
};

export const DispatchCompleteDiscrepancyCollection: HandlerType = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/CompleteLoadDiscrepancyCollection",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteDiscrepancyCollection];

export const loadDiscrepancyCollection = createHandlerChainRunner(chain, "loadDiscrepancyCollection");
export default loadDiscrepancyCollection;
